import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "ml10"
}, "字段", -1);
const _hoisted_3 = {
  class: "dialog-footer"
};
import { reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Plus, Minus } from "@element-plus/icons-vue";
import separateUpload from "@/components/separate-upload/index.vue";
import { ElMessage } from "element-plus";
import { setDictStatusApi, getDictapi } from "@/service/modules/role";
export default /*#__PURE__*/_defineComponent({
  __name: 'dic_dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    keys: {
      type: String,
      default: ""
    }
  },
  emits: ["closeDialog", "restData"],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const emit = __emit;
    const subBtnLoading = ref(false);
    const props = __props;
    const closeDialog = () => {
      emit("closeDialog");
    };
    const form_data = reactive({
      name: "",
      key: "",
      value: "",
      list: []
    });
    const formRef = ref();
    const rules = {
      name: [{
        required: true,
        message: "请输入字典名称",
        trigger: "blur"
      }, {
        min: 1,
        max: 20,
        message: "长度在 1 到 20 个字符",
        trigger: "blur"
      }],
      key: [{
        required: true,
        message: "请输入字典key",
        trigger: "blur"
      }, {
        min: 1,
        max: 20,
        message: "长度在 1 到 20 个字符",
        trigger: "blur"
      }]
    };
    function handleFooterBtn(actionType) {
      if (!actionType) {
        closeDialog();
        return;
      }
      formRef.value?.validate(valid => {
        if (valid) {
          submit();
        }
      });
    }
    async function submit() {
      subBtnLoading.value = true;
      form_data.value = JSON.stringify(form_data.list);
      const res = await setDictStatusApi(form_data);
      emit("restData");
      subBtnLoading.value = false;
    }
    async function init() {
      if (props.keys) {
        console.error("key值222不存在");
        const res = await getDictapi(props.keys);
        form_data.name = res.data.name;
        form_data.key = res.data.key;
        form_data.value = res.data.value;
        form_data.list = JSON.parse(res.data.value);
      } else {
        form_data.name = "";
        form_data.key = "";
        form_data.value = "";
        form_data.list.push({
          id: Math.random(),
          label: "",
          value: ""
        });
      }
    }
    init();
    const onAddRow = () => {
      form_data.list.push({
        id: Math.random(),
        label: "",
        value: ""
      });
    };
    // 删除行
    const onDelRow = k => {
      form_data.list.splice(k, 1);
    };
    function imgLoadSuccess(img, index) {
      form_data.list[index].value = img;
    }
    function imgTypeError() {
      ElMessage.warning("仅支持jpg/jpeg/png格式图片");
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: "字典数据",
        width: "35%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: subBtnLoading.value,
          onClick: _cache[4] || (_cache[4] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form_data,
          "label-width": "auto",
          ref_key: "formRef",
          ref: formRef,
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "字典名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form_data.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form_data.name = $event),
              placeholder: "请输入字典名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "字典key",
            prop: "key"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form_data.key,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form_data.key = $event),
              placeholder: "请输入字典key"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "字典值"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form_data.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form_data.value = $event),
              placeholder: "请输入字典值"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24,
            class: "mb20"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form_data.list, (v, k) => {
              return _openBlock(), _createBlock(_component_el_row, {
                gutter: 35,
                key: k
              }, {
                default: _withCtx(() => [_createVNode(_component_el_col, {
                  xs: 24,
                  sm: 12,
                  md: 12,
                  lg: 12,
                  xl: 12,
                  class: "mb20"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    prop: `list[${k}].label`
                  }, {
                    label: _withCtx(() => [k === 0 ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      circle: "",
                      size: "small",
                      onClick: onAddRow
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [_createVNode(_unref(Plus))]),
                        _: 1
                      })]),
                      _: 1
                    })) : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "danger",
                      circle: "",
                      size: "small",
                      onClick: $event => onDelRow(k)
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [_createVNode(_unref(Minus))]),
                        _: 1
                      })]),
                      _: 2
                    }, 1032, ["onClick"])), _hoisted_2]),
                    default: _withCtx(() => [_createVNode(_component_el_input, {
                      modelValue: v.label,
                      "onUpdate:modelValue": $event => v.label = $event,
                      style: {
                        "width": "100%"
                      },
                      placeholder: "请输入字段名"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
                    _: 2
                  }, 1032, ["prop"])]),
                  _: 2
                }, 1024), _createVNode(_component_el_col, {
                  xs: 24,
                  sm: 12,
                  md: 12,
                  lg: 12,
                  xl: 12,
                  class: "mb20"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "属性",
                    prop: `list[${k}].value`
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_input, {
                      modelValue: v.value,
                      "onUpdate:modelValue": $event => v.value = $event,
                      style: {
                        "width": "100%"
                      },
                      placeholder: "请输入属性值"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createVNode(separateUpload, {
                      maxSize: 1,
                      accept: ".jpg, .png, .jpeg",
                      "file-types": ['image/png', 'image/jpeg'],
                      onTypeError: imgTypeError,
                      onUploadSuccess: $event => imgLoadSuccess($event, k)
                    }, null, 8, ["onUploadSuccess"])]),
                    _: 2
                  }, 1032, ["prop"])]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model-value"])]);
    };
  }
});